export default "__VITE_ASSET__ByJeIXVb__"